import { Button, Heading, Text } from '@mallpay/orbis';
import React from 'react';

import { ReactComponent as IconCheck } from '@skippay/core/assets/icons/icon-check-circle-filled.svg';
import { usePageview } from '@skippay/core/components/GoogleAnalytics';
import { FormattedMessage } from '@skippay/core/i18n/intl';

import { OVERVIEW } from 'constants/routes';
import { FooterButtons } from 'layout/MinimalLayout/components/FooterButtons';

function Success(): JSX.Element {
	usePageview({ pTitle: 'bnpl_limit_management_success' });

	return (
		<section className="mx-auto px-4 pt-6 pb-8">
			<div className="mb-4 flex flex-col gap-8">
				<Text as="div" className="text-center">
					<IconCheck className="h-20 w-20" />
				</Text>

				<div className="flex flex-col gap-3">
					<Heading as="h1" className="text-center">
						<FormattedMessage id="BnplLimitManagement.success.title" defaultMessage="Hotovo!" />
					</Heading>

					<div className="mt-4">
						<Text as="div" className="text-center">
							<FormattedMessage
								id="BnplLimitManagement.success.description"
								defaultMessage="Všechno klaplo, Limity jsou vaše a vy můžete nakupovat jedním kliknutím jako dřív.{br}{br} Podmínky Limitů najdete v Zákaznické zóně v sekci Dokumenty."
								values={{
									br: <br />,
								}}
							/>
						</Text>
					</div>
				</div>
			</div>

			<FooterButtons
				content={
					<Button
						className="w-full"
						testId="bnplVerifyIdentity"
						analyticsParam="bnplVerifyIdentity"
						variant="primary"
						to={OVERVIEW}
					>
						<FormattedMessage id="BnplLimitManagement.success.close" defaultMessage="Zavřít" />
					</Button>
				}
			/>
		</section>
	);
}

export default Success;
